import React, { Component } from 'react';
import moment from 'moment';
import {plus} from 'react-icons-kit/icomoon/plus';
import SvgIcon from 'react-icons-kit';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import {Table} from 'react-bootstrap';
import {bin} from 'react-icons-kit/icomoon/bin';
import $ from 'jquery';
import swal from 'sweetalert';

export default class Following extends Component{
	constructor(props){
		super(props);

		this.state = {show_form: false};
	}

	componentDidMount(){
		$(document).on('blur', '#date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');

				setTimeout(()=>{
					$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');
						this.props.handleChange('follow', 'date', '');
				}, 3000)
				
				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});
	}

	render(){
		return (
			<div className="col-xs-12 data-modal">
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">Nombre del donador: </span>
					</div>
					<div className="col-xs-12 col-sm-8">
						{this.props.data.donor_name}
					</div>
				</div>
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">Fecha de donación: </span>
					</div>
					<div className="col-xs-12 col-sm-8">
						{moment(this.props.data.donation_date).format('DD/MM/YYYY')}
					</div>
				</div>
				

				<div className="col-xs-12">
					<div className="col-xs-12 form-group">
						<span className="span-min">Telefonos registrados </span> 
						<button className="btn btn-info" style={{marginLeft:8}}
							onClick={(e)=>{e.preventDefault(); return this.setState({show_form: !this.state.show_form})}}>
							Agregar
						</button>
					</div>
					{this.state.show_form &&
						<div>
							<div className="col-xs-12">
								<span className="span-min">Telefono registrado: </span>
							</div>
							<div className="col-xs-12 col-sm-4 form-group">
								<select className="form-control" name="phone_type" id="phone_type" value={ this.props.follow.phone_type || "" } 
									onChange={ (e)=>this.props.handleChange('follow', 'phone_type', e.target.value) }  >
									<option value="" disabled></option>
										{this.props.follow.phoneTypes.map((t) => (
											<option key={t.id}  value={t.key}>{t.name}</option>
										))
									}
								</select>
							</div>
							<div className="col-xs-12 col-sm-4 form-group">
								<MaskedFormControl type='text' name="phone_number" id="phone_number" value={ this.props.follow.phone_number } 
									mask='111-111-1111' className="form-control" onChange={(e)=>this.props.handleChange('follow', 'phone_number', e.target.value)}
								/>
							</div>
							<div className="col-xs-12 col-sm-4 form-group">
								<button className="btn btn-info btn-xs"
									onClick={(e)=>this.props.addPhone(this.props.follow)}>
									<SvgIcon size={10} icon={plus} />
								</button>
							</div>
						</div>
					}
					<div className="col-xs-12 form-group">
						<Table responsive hover>
							<thead>
								<tr>
									<th>Tipo</th>
									<th>Telefono</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{this.props.follow.phones.map((p, i)=>(
									<tr key={i}>
										<td>{p.type}</td>
										<td>{p.number}</td>
										<td>
											{/*<button className="btn btn-xs" onClick={(e)=>this.props.removePhone(i)}>
												<SvgIcon size={15} icon={bin} />
											</button>*/}
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>
				</div>

				<div className="col-xs-12 form-group">
					{console.log(this.props.follow.comments)}
					{this.props.follow.comments !== undefined &&
						this.props.follow.comments.map((c, i)=>
							<div className="col-xs-12">
								<div className="col-xs-12">
									<span className="span-min">
										{
										(c.status !== null ? c.status : "")+' - '+
										moment(c.timestamp).format('DD/MM/YYYY HH:mm')+' - '+
										c.user
										}
									</span>
								</div>
								<div className="col-xs-12">
									<textarea  value={c.comments}
										style={{height:"80px",width:"100%",resize:"none"}}
										className="form-control" disabled
										onChange={(e)=>e.preventDefault()}></textarea>
								</div>
							</div>
						)
					}
				</div>

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">Estatus: </span>
					</div>
					<div className="col-xs-12 col-sm-8">
						<select name="status" id="status" value={this.props.follow.status}
							className="form-control" required
							onChange={(e)=>this.props.handleChange('follow', 'status', e.target.value)}>
							<option value="">Seleccione...</option>
							{this.props.follow.status_list.map((s, i)=>(
								<option key={i} value={s.value}>{s.name}</option>
							))}
						</select>
					</div>
				</div>
				<div className="col-xs-12 form-group">
					<span className="span-min">Comentario: </span>
					<textarea name="comment" id="comment" value={this.props.follow.comment}
						style={{height:"80px",width:"100%",resize:"none"}}
						className="form-control" 
						onChange={(e)=>this.props.handleChange('follow', 'comment', e.target.value)}></textarea>
				</div>
				
				<div className="col-xs-12">
					<div className="col-xs-12 col-sm-6">
						<input type="checkbox" name="'agenda" id="agenda" 
							value={this.props.follow.agenda} checked={this.props.follow.agenda}
							onChange={(e)=>this.props.handleChange('follow', 'agenda', e.target.checked)} />
						<span className="span-min" style={{marginLeft:'8px'}}>Agendar Recordatorio</span>
					</div>
				</div>
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-4">
						<input type="date" name="date" id="date"  className="form-control"
							value={this.props.follow.date} checked={this.props.follow.date}
							required={this.props.follow.agenda}
							onChange={(e)=>this.props.handleChange('follow', 'date', e.target.value)} />
						
					</div>
				</div>
			</div>
		)
	}
	
}